import { Component, computed, inject, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { Button } from 'primeng/button';
import { InputText } from 'primeng/inputtext';
import { Message } from 'primeng/message';
import { ScrollPanel } from 'primeng/scrollpanel';
import { OpkraevningsListerService } from '../opkraevningslister.service';
import { OpkraevningsListerSearchParams } from './opkraevningslister-search-params.model';
import { LetInputCprComponent } from '@shared/let-input-cpr/let-input-cpr.component';

@Component({
  selector: 'app-opkraevningslister-search',
  imports: [
    ReactiveFormsModule,
    CheckboxModule,
    Button,
    InputText,
    Message,
    ScrollPanel,
    LetInputCprComponent
  ],
  templateUrl: './opkraevningslister-search.component.html',
  styleUrl: './opkraevningslister-search.component.css',
})
export class OpkraevningsListerSearchComponent {
  opkraevningsListerService = inject(OpkraevningsListerService);
  data = this.opkraevningsListerService.datasource.data;
  validationMessage = signal('');

  form = new FormGroup({
    regnr: new FormControl(),
    koerselsNr: new FormControl(),
    cprNummer: new FormControl(),
    ikkeAfsendte: new FormControl(false),
  });

  onClickSearch() {
    this.opkraevningsListerService.searchOpkraevningsListe({
      ...(this.form.value as OpkraevningsListerSearchParams),
      searchTime: new Date(),
    });
  }

  onClickReset() {
    this.form.reset();
  }

  noHits = computed(() => {
    return (
      this.opkraevningsListerService.datasource.isLoaded() &&
      this.data()?.totalRowCount == 0
    );
  });
}
